import Vue from "vue";
import axiosEx from "@/scripts/axiosEx.js";

//http://authtest.ningmengyun.com
const apimUrls = {
	apimUser: {
		User: 'get /api/user/user',
	}
};
//http://authtest.ningmengyun.com
const authUrls = {
	user: {
		VCode: "/api/Registerv2",
		TencentCaptcha: "get /api/TencentCaptcha",
		Register: "postJson /api/Internal?ClientType=1017",
		Login: '/oauth/token',
		RegisterLogin: '/unionregister/register',
	}
};
//http://j2test.ningmengyun.com
const j2Urls = {
	j2Api: {
		Logout: "get /api/logout.ashx",
		userName: "/Default/Services/ChangeNickName.ashx",
		verifyPass: "/Default/Services/SendSMSForVerify.ashx?type=2",
		SaveMobile: "/Default/Services/SubmitForPersonalInfo.ashx",
		SavePass: "get /api/SubmitForNewPassword.ashx",
		SendCode: "/api/SendSMSForRegister.ashx",
	}
};
//http://jmtest.ningmengyun.com
const jmUrls = {
	jmApi: {
		UploadImg: "postFile /me/UploadHeadImg",
		CheckMobile: "/me/CheckMobile",
		KeyPoint: "/api/BossReport",
		ExpensesReport: "api/FinancialAnalysis",
		PeriodSectionPicker: "/AccountBooksPartical/_PeriodSectionPicker",
		IncomeSheet: "getUrl /odata/IncomeSheet?pid=",
		IncomeQuarterSheet: "getUrl /odata/IncomeQuarterSheet",
		BusinessActivitySheet: "getUrl /odata/BusinessActivitySheet?pid=",
		SurplusDistributionSheet: "getUrl /odata/SurplusDistributionSheet?pid=",
		BalanceSheet: "get /odata/BalanceSheet",
		AcList: "get /odata/AccountSetV3",
		ChangeAa: "/AccountSet/AccountSetChangeV2",
		AsubOptions: "/SubsidiaryLedger/AsubOptions",
		IncomePay: "get /api/ARAPDetail",
		Kpi: "get /api/KPI",
		Sub: "/TrialBalance/Items",
		SubsidiaryLedger: "/SubsidiaryLedger/Items",
		CapitalDetail: "get /api/FundDetail",
		CostDetail: "get /api/CostDetail",
		UserCheck: "getUrl /Account/UserCheck?",
		BossLogin: "get /api/BossLogin",
		BossLoginLog: "postUrl /api/BossLogin",
		BossLoginBefore:'get /api/BossLogin/GetComplete'
	}
};
// const j3Urls = {
// 	j3Api: {
// 		GetPCAdvertisement: "/Default/Services/GetPCAdvertisement.ashx"
// 	}
// };
// const toutiaoUrls = {
// 	toutiaoApi: {
// 		AliyunSts: 'get /api/common/AliyunStsForApp'
// 	}
// };

const dzUrls = {
	framework: {
		ChangeAa: "postUrl /BaseData/ChangeAa?aaid=",
	},
	bind: {
		SearchOpenId: "postUrl /UrlGen/SearchOpenId",
		Bind: "/UrlGen/BindH5",
		HasBind: "postUrl /UrlGen/HasBind?state=&code=",
		UnBind: "postUrl /UrlGen/UnBind?openId="
	},
	dzApi: {
		AaService: "get /BossH5/SearchServices",
		AaServiceDetails: "getUrl /BossH5/GetAaServiceDetails?serviceId=",
		IcServiceDetails: "getUrl /BossH5/GetIcServiceDetails?serviceId=",
		SearchCompany: "getUrl /BossH5/SearchCompany?custId=",
		ContractSearch: "get /BossH5/SearchContracts",
		GetContractDetails: "getUrl /BossH5/GetContractDetails?contractId=",
		SearchAaCompany: "getUrl /BossH5/SearchAaCompany?aaId=",
		SearchAaCompanies: "getUrl /BossH5/SearchAaCompanies?phone=",
		CashDetail: "get /BossH5/GetTaxInfo",
		GetCompanyList:"get /BossH5/GetCustomers"
	},
	customer: {
		VerifyAuth: "postUrl /Customer/VerifyAuth"
	}
};



const jmProUrls = {
	jmProApi:{
		AcList:'get /odata/AccountSetV3',
		UserCheck: "getUrl /Account/UserCheck?",
		BossLogin: "get /api/BossLogin",
		Kpi: "get /api/KPI",
		ChangeAa: "/AccountSet/AccountSetChangeV2",
		CapitalDetail: "get /api/FundDetail",
		CostDetail: "get /api/CostDetail",
		IncomePay: "get /api/ARAPDetail",
		BusinessActivitySheet: "getUrl /odata/BusinessActivitySheet?pid=",
		SurplusDistributionSheet: "getUrl /odata/SurplusDistributionSheet?pid=",
		Sub: "/TrialBalance/Items",
		AsubOptions: "/SubsidiaryLedger/AsubOptions",
		SubsidiaryLedger: "/SubsidiaryLedger/Items",
		BalanceSheet: "get /odata/BalanceSheet",
		UploadImg: "postFile /me/UploadHeadImg",
		BossLoginLog: "postUrl /api/BossLogin",
		PeriodSectionPicker: "/AccountBooksPartical/_PeriodSectionPicker",
		IncomeSheet: "getUrl /odata/IncomeSheet?pid=",
		IncomeQuarterSheet: "getUrl /odata/IncomeQuarterSheet",
		KeyPoint: "/api/BossReport",
		BossLoginBefore:'get /api/BossLogin/GetComplete'

		// CheckMobile: "/me/CheckMobile",
		// ExpensesReport: "api/FinancialAnalysis",
	} 
}


const erpUrls = {
	erpApi:{
		AcList:'get /odata/AccountSetV3',
		UserCheck: "getUrl /Account/UserCheck?",
		BossLogin: "get /api/BossLogin",
		Kpi: "get /api/KPI",
		ChangeAa: "/AccountSet/AccountSetChangeV2",
		CapitalDetail: "get /api/FundDetail",
		CostDetail: "get /api/CostDetail",
		IncomePay: "get /api/ARAPDetail",
		BusinessActivitySheet: "getUrl /odata/BusinessActivitySheet?pid=",
		SurplusDistributionSheet: "getUrl /odata/SurplusDistributionSheet?pid=",
		Sub: "/TrialBalance/Items",
		AsubOptions: "/SubsidiaryLedger/AsubOptions",
		SubsidiaryLedger: "/SubsidiaryLedger/Items",
		BalanceSheet: "get /odata/BalanceSheet",
		UploadImg: "postFile /me/UploadHeadImg",
		BossLoginLog: "postUrl /api/BossLogin",
		PeriodSectionPicker: "/AccountBooksPartical/_PeriodSectionPicker",
		IncomeSheet: "getUrl /odata/IncomeSheet?pid=",
		IncomeQuarterSheet: "getUrl /odata/IncomeQuarterSheet",
		KeyPoint: "/api/BossReport",
		BossLoginBefore:'get /api/BossLogin/GetComplete'

		// CheckMobile: "/me/CheckMobile",
		// ExpensesReport: "api/FinancialAnalysis",
	} 
}

const {
	$get,
	$postJson,
	$post,
	$getFile,
	$postFile,
	$delete,
	$deleteJson,
} = axiosEx;
let allPost = {};

function convertUrls(baseUrl, urls, key) {
	const sUrl = urls[key];
	allPost[key] = {};
	for (const uKey in sUrl) {
		if (sUrl.hasOwnProperty(uKey)) {
			// allPost.user.VCode=function
			allPost[key][uKey] = function(args) {
				let __urlSplits = urls[key][uKey].split(" ");
				if (__urlSplits.length >= 2) {
					switch (__urlSplits[0]) {
						case "get":
							return $get(baseUrl + __urlSplits[1], args);
						case "getFile":
							return $getFile(baseUrl + __urlSplits[1], args);
						case "getFileUrl":
							return $getFile(baseUrl + __urlSplits[1] + args);
						case "postFile":
							return $postFile(baseUrl + __urlSplits[1], args);
						case "getUrl":
							return $get(baseUrl + __urlSplits[1] + args);
						case "postUrl":
							return $post(baseUrl + __urlSplits[1] + args);
						case "deleteJson":
							return $deleteJson(baseUrl + __urlSplits[1], args);
						case "delete":
							return $delete(baseUrl + __urlSplits[1], args);
						case "deleteUrl":
							return $delete(baseUrl + __urlSplits[1] + args);
						case "postJson":
							return $postJson(baseUrl + __urlSplits[1], args);
						case "postJsonUrlAndBody":
							return $postJson(baseUrl + __urlSplits[1] + args[0], args[1] || null);
						default:
							return $post(baseUrl + urls[key][uKey], args);
					}
				} else {
					return $post(baseUrl + urls[key][uKey], args);
				}
			};
		}
	}
}

for (const key in dzUrls) {
	convertUrls('/dzUrls', dzUrls, key);
}
for (const key in apimUrls) {
	convertUrls('/apimUrls', apimUrls, key);
}
for (const key in authUrls) {
	convertUrls('/authUrls', authUrls, key);
}
for (const key in j2Urls) {
	convertUrls('/j2Urls', j2Urls, key);
}
for (const key in jmUrls) {
	convertUrls((window.lm_env == 'jz' ? 'jzJMUrls' : '/dzJMUrls'), jmUrls, key);
}


for (const key in jmProUrls) {
	convertUrls('jzJMProUrls', jmProUrls, key);
}

for (const key in erpUrls) {
	convertUrls('erpUrls', erpUrls, key);
}



Vue.prototype.$lmsvr = allPost;

